import { render, staticRenderFns } from "./DreamAdd.vue?vue&type=template&id=1554b002&scoped=true&"
import script from "./DreamAdd.vue?vue&type=script&lang=ts&"
export * from "./DreamAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1554b002",
  null
  
)

export default component.exports